import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

/**
 * Props:
 *   page        – current page (1-based)
 *   totalPages  – total number of pages
 *   totalItems  – total record count
 *   pageSize    – records per page
 *   onPageChange – (newPage) => void
 */
const LogPagination = ({ page, totalPages, totalItems, pageSize, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  const from = (page - 1) * pageSize + 1;
  const to   = Math.min(page * pageSize, totalItems);

  // Build visible page numbers (max 7 buttons)
  const pages = [];
  const delta = 2;
  const left  = Math.max(2, page - delta);
  const right = Math.min(totalPages - 1, page + delta);

  pages.push(1);
  if (left > 2) pages.push('…');
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < totalPages - 1) pages.push('…');
  if (totalPages > 1) pages.push(totalPages);

  return (
    <div className="al-pagination">
      <span className="al-page-info">
        Showing {from}–{to} of {totalItems.toLocaleString()} records
      </span>

      <div className="al-page-controls">
        <button
          className="al-page-btn"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
        >
          <FaChevronLeft />
        </button>

        {pages.map((p, i) =>
          p === '…' ? (
            <span key={`ellipsis-${i}`} style={{ padding: '0 4px', color: '#9ca3af' }}>…</span>
          ) : (
            <button
              key={p}
              className={`al-page-btn ${p === page ? 'active' : ''}`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          )
        )}

        <button
          className="al-page-btn"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
        >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default LogPagination;
